// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_7k-4";
export var collapsed = "_7k-1";
export var headerBar = "_7k-0";
export var leftHeaderContent = "_7k-3";
export var subjectContainer = "_7k-2";